// @flow

export type DraggableData = {
    node: HTMLElement,
    x: number,
    y: number,
    deltaX: number,
    deltaY: number,
    lastX: number,
    lastY: number
};

export default class DragHelper {
    static positionToTime(
        container: HTMLElement,
        dragStartTime: number,
        dragStartX: number,
        x: number,
        duration: number
    ): number {
        const delta = x - dragStartX;
        return dragStartTime + (duration * delta) / container.offsetWidth;
    }
}



// WEBPACK FOOTER //
// ./src/app/util/DragHelper.js